// extracted by mini-css-extract-plugin
export var dropdownButton = "_3h-0";
export var fullWidthDropdownButton = "_3h-1";
export var icon = "_3h-3";
export var iconPlaceholder = "_3h-2";
export var menuItemRow = "_3h-8";
export var separator = "_3h-c";
export var shortcutContainer = "_3h-7";
export var shortcutIconLg = "_3h-6";
export var shortcutIconMd = "_3h-5";
export var shortcutIconSm = "_3h-4";
export var submenuChevron = "_3h-b";
export var submenuDropdown = "_3h-9";
export var submenuTriggerRow = "_3h-a";